/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/no-array-index-key */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Collapse, Card, CardBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CardHeader, ErrorBoundary } from '@cordata/buffet';
import { findIndex } from 'lodash';

const Accordian = ({
  items,
  openPanel: op,
  setOpenPanel,
  allOpen,
}) => {
  const [openCollapse, setOpenCollapse] = useState();

  useEffect(() => {
    if (op !== null || op !== undefined) {
      setOpenCollapse(typeof op === 'number' ? op : findIndex(items, i => i.title === op));
    }
  }, [op]);

  const isOpen = i =>
    i === openCollapse || allOpen || items.length === 1;

  return (
    <Card>
      {items
        .filter(i => (
          Object.prototype.hasOwnProperty.call(i, 'visible')
            ? i.visible
            : true))
        .map(({ title, titleAction, body }, i) => (
          <React.Fragment key={`${title}-${i}`}>
            <CardHeader
              className="text-uppercase font-weight-bold d-print-none"
              style={{
                backgroundColor:
                  isOpen(i) ? '#ced4da' : 'white',
              }}
            >
              <div
                className="d-inline-flex align-items-center"
              >
                <div
                  role="navigation"
                  onClick={() => {
                    setOpenCollapse(i === openCollapse ? -1 : i);
                    setOpenPanel(i === openCollapse ? undefined : title);
                  }}
                >
                  <FontAwesomeIcon
                    icon={
                      isOpen(i) ? 'chevron-down' : 'chevron-right'
                    }
                    className="mr-2 text-muted"
                    fixedWidth
                  />

                  <span style={{ color: '#1d3b4e' }}>{title}</span>
                </div>

                {openCollapse === i && titleAction}
              </div>
            </CardHeader>

            {(isOpen(i)) && (
              <>
                <h3 className="d-none d-print-block ml-4 mt-3">{title}</h3>
              </>
            )}

            <Collapse isOpen={isOpen(i)}>
              {(isOpen(i)) && (
                <ErrorBoundary>
                  <CardBody className="print-table border-bottom">{body}</CardBody>
                </ErrorBoundary>
              )}
            </Collapse>
          </React.Fragment>
      ))}
    </Card>
  );
};

Accordian.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
    body: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
  })).isRequired,
  openPanel: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setOpenPanel: PropTypes.func,
  allOpen: PropTypes.bool,
};

Accordian.defaultProps = {
  openPanel: -1,
  allOpen: false,
  setOpenPanel: () => {},
};

export default Accordian;
